import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { NAV, SITE } from "../data/content";
import LanguageToggle from "./LanguageToggle";
import lkLogo from "../assets/lk-logo.png";

export default function Navbar() {
  const { t } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = (id) => (e) => {
    if (location.pathname !== "/") return; // let router handle
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav
      data-testid="main-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-ink/85 backdrop-blur-xl border-b border-parchment-faint"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5 flex items-center justify-between">
        <Link
          to="/"
          className="group inline-flex items-center gap-2.5 font-serif text-xl tracking-tight text-parchment hover:text-four-yellow transition-colors"
          data-testid="nav-brand"
        >
          <img
            src={lkLogo}
            alt="LK"
            className="h-[60px] w-[60px] object-contain"
            style={{ mixBlendMode: "screen" }}
          />
          <span>
            {t(SITE.name.en, SITE.name.he)}
            <span className="text-parchment-dusk">.</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-10 text-sm tracking-widest uppercase text-parchment/80">
          {NAV.map((item) => (
            <Link
              key={item.id}
              to={location.pathname === "/" ? `#${item.id}` : `/#${item.id}`}
              onClick={handleNavClick(item.id)}
              className="hover:text-parchment transition-colors"
              data-testid={`nav-${item.id}`}
            >
              {t(item.en, item.he)}
            </Link>
          ))}
        </div>

        <LanguageToggle />
      </div>
    </nav>
  );
}
